import React from 'react'

import ModelEntity from "../../../../model2/model-entity";
import {EntityType} from "../../../../gd/const/item";
import Task from "../../../../model2/task/task";
import Event from "../../../../model2/event/event";
import Project from "../../../../model2/project/project";
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover";

const debug = false
// const debug = "DependencyItem"

type Props = {
    item        : ModelEntity
}

export default function DependencyItem (props:Props) {


    const onClick = () => {
        // gd.taskView.open(props.item.taskId)
        props.item.goTo()
    }

    // const onClickTask = () => {
    //     gd.taskView.open(props.item.taskId)
    // }

    debug && console.log(debug, 'render', props.item)

    switch (props.item.itemType) {
        case EntityType.PROJECT:
            const project : Project = props.item as Project
            return (
                <div className="ui5-property m-r-5 max-w-80" onClick={onClick}>
                    {/*project #{project.id}*/}
                    {project.name}
                    <HintPopover hint={project.name}/>
                </div>
            )

        case EntityType.EVENT:
            const event : Event = props.item as Event
            return (
                <div className="ui5-property m-r-5 max-w-80" onClick={onClick}>
                    {/*event #{event.id}*/}
                    {event.name}
                    <HintPopover hint={event.name}/>
                </div>
            )

        case EntityType.TASK:
        default:

            const task : Task = props.item as Task

            return (
                <div className="ui5-property m-r-5" onClick={onClick}>
                    #{task.shortId}
                    <HintPopover hint={task.title}/>
                </div>
            )
    }

}
